import React, {Component} from "react";  import config from 'react-global-configuration';
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import $ from "jquery";
import jwt_decode from "jwt-decode";
import axios from "axios";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class MyRequests extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            mvalue: {year: new Date().getFullYear(), month: 11},
            fileType:'Base and EMI',
            _notificationSystem: null,
            loading:false,
            isSubmit:false,
            requestsTable:true,
            reqDetailsTable:false,
            ticketDetailsTable:false,
            sub_req_no:'',
            sub_time_submitted:'',
            sub_emi_type:'',
            sub_utid_req:'',
            sub_utid_issued:'',
            uploaded_file:'',
            ticketDeails:[],
            ticketBtids:[]
        };

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this.showRequests()
        ///$('#RequestTable').DataTable();
    }
    showRequests(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if ($.fn.DataTable.isDataTable('#RequestTable')) {
            $('#RequestTable').DataTable().destroy();
        }

       // $('#RequestTable').html('');
        var req = $('#RequestTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : true,
                "autoWidth": false,
                "responsive": false,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/anycardemi/get-req?email="+decoded.email,
                    type: 'GET',
                    dataSrc:function ( json ) { console.log("dataaaaa");
                    console.log(json.data);
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                columns: [
                    {"data":"request_no"},
                    {"data":"submission_time"},
                    {"data":"emi_type"},
                    {"data":"total_utid_requested"},
                    {"data":"total_utid_issued"},
                    {"data":"status"},
                ],
                "columnDefs": [

                    {
                        "targets": 0,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');
                                $(td).append('<a href="#"  data-tip="" title="details" id=""  class="" >'+rowData.request_no+'</a>');
                                $(td).click(e => {
                                    this.reqDetails(e,rowData);
                                })
                        },
                        bSortable: false,
                    },
                    {
                        render: function (data) {
                            var type = data;
                            if(type==='easy') {
                                type = 'EASY EMI';
                            }
                            else {
                                type = 'ANY CARD EMI';
                            }
                            return '<td >'+type+'</td>';
                        },
                        targets: 2,
                        aTargets: [ -1 ]
                    },
                    {
                        render: function (data) {
                            var totalIssued = data;
                            if(data===null || data=='null') {
                                totalIssued = 0;
                            }
                            return '<td >'+totalIssued+'</td>';
                        },
                        targets: 4,
                        aTargets: [ -1 ]
                    }
                    ]
            });
    }
    reqDetails(e, rowdata){
        //alert(rowdata.request_no)
        var iutid = rowdata.total_utid_issued;
        if(rowdata.total_utid_issued===null || rowdata.total_utid_issued=='null') {
            iutid =0;
        }
        var iutidr = rowdata.total_utid_requested;
        if(rowdata.total_utid_requested===null || rowdata.total_utid_requested=='null') {
            iutidr =0;
        }
        this.setState({
            requestsTable:false,
            reqDetailsTable:true,
            ticketDetailsTable:false,
            sub_req_no: rowdata.request_no,
            sub_time_submitted:rowdata.submission_time,
            sub_emi_type:rowdata.emi_type,
            sub_utid_req:iutidr,
            sub_utid_issued:iutid,
            uploaded_file:''
        });
        if ($.fn.DataTable.isDataTable('#RequestDetailsTable')) {
            $('#RequestDetailsTable').DataTable().destroy();
        }

        // $('#RequestTable').html('');
        var req = $('#RequestDetailsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : true,
                "autoWidth": false,
                "responsive": false,
                "lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/anycardemi/get-request-details?req_no=" + rowdata.request_no,
                    type: 'GET',
                    dataSrc:function ( json ) {
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                columns: [
                    {"data":"ticket_no"},
                    {"data":"call_id"},
                    {"data":"merchant_name"},
                    {"data":"pincode"},
                    {"data":"city"},
                    {"data":"state"},
                    {"data":"base_tid"},
                    {"data":"ticket_status"},
                    {"data":"assigned_to"},
                    {"data":"btid"},
                ],
                "columnDefs": [
                    {
                        "targets": 0,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');
                            $(td).append('<a href="#"  data-tip="" title="details" id=""  class="" >'+rowData.ticket_no+'</a>');
                            $(td).click(e => {
                                this.TicketDetails(e,rowData);
                            })
                        },
                        bSortable: false,
                    }]
            });

    }
    reqDetails_back() {

        this.setState({
            requestsTable:false,
            reqDetailsTable:true,
            ticketDetailsTable:false,
       });
        if ($.fn.DataTable.isDataTable('#RequestDetailsTable')) {
            $('#RequestDetailsTable').DataTable().destroy();
        }

        // $('#RequestTable').html('');
        var req = $('#RequestDetailsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : true,
                "autoWidth": false,
                "responsive": false,
                "lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/anycardemi/get-request-details?req_no=" + this.state.sub_req_no,
                    type: 'GET',
                    dataSrc:function ( json ) {
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                columns: [
                    {"data":"ticket_no"},
                    {"data":"call_id"},
                    {"data":"merchant_name"},
                    {"data":"pincode"},
                    {"data":"city"},
                    {"data":"state"},
                    {"data":"base_tid"},
                    {"data":"ticket_status"},
                    {"data":"assigned_to"},
                    {"data":"btid"},
                ],
                "columnDefs": [
                    {
                        "targets": 0,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');
                            $(td).append('<a href="#"  data-tip="" title="details" id=""  class="" >'+rowData.ticket_no+'</a>');
                            $(td).click(e => {
                                this.TicketDetails(e,rowData);
                            })
                        },
                        bSortable: false,
                    }]
            });
    }
    viewType(){
        this.setState({
            requestsTable:true,
            reqDetailsTable:false,
            ticketDetailsTable:false,
        });
        setTimeout(function(){
            this.showRequests()
            }.bind(this), 500);
    }
    TicketDetails(e, rowdata){
        //alert(rowdata.ticket_no);
        this.setState({
            ticketDeails:[],
            ticketBtids:[]
        });
        axios.get(config.get('API_URL')+'/anycardemi/ticket-details/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                ticket_no: rowdata.ticket_no
            }
        }).then(response => {
            console.log("ticketDetails");
            console.log(response);
            this.setState({
                ticketDeails:response.data.data,
                ticketBtids: response.data.data.btids
            })
        });
        this.setState({
            requestsTable:false,
            reqDetailsTable:false,
            ticketDetailsTable:true,
        })
    }
    viewType1(){
        this.setState({
            requestsTable:false,
            reqDetailsTable:true,
            ticketDetailsTable:false,
        });
        setTimeout(function(){
            this.reqDetails_back()
        }.bind(this), 1000);
    }
    render() {
        console.log("dddddddddddd");
        console.log(this.state.ticketDeails);
        let databtids = this.state.ticketBtids.map((val,index) => {


            return (
                <tr key={index + 1}>
                    <td>{val.btid}</td>
                    <td>{val.tenure}</td>
                    <td>{val.roi}</td>

                </tr>
            )
        });
        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="">
                            <div className="">
                                <div className="header">
                                    <p className="category"></p>
                                </div>
                                <div className="">
                                    {this.state.requestsTable===true?
                                    <div className="content-tdetails-table table-full-width table-responsive">
                                        <table id="RequestTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Request No.</th>
                                                <th>Submission Time</th>
                                                <th>EMI Type</th>
                                                <th>UID's Requested</th>
                                                <th>UID's Issued</th>
                                                <th>Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>

                                        </table>
                                        <div className="gap_ver"></div>
                                        <div className="col-md-3 pull-right">
                                            {/*<button width="100%" type="button" className="btn btn-secondary">Cancel</button> &nbsp;*/}
                                            {/*<button width="100%" type="button" className="btn btn-primary" onClick={this.createUTID.bind(this)}>Create UTID</button>*/}
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="gap_ver"></div>
                                    </div> : null }
                                    {this.state.reqDetailsTable===true?
                                        <div className="reqdetailsContain">
                                            <h4 className="nomargin">Request Details</h4>
                                            <div className="row">
                                                <div className="col-md-1 back-arrow-div">
                                                    <a href="#" onClick={this.viewType.bind(this,'')}><i className="fa fa-angle-left" aria-hidden="true"></i></a>
                                                </div>

                                                <div className="col-md-4">
                                                    <div>
                                                        <div className="col-md-5"><label>INN Request No:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.sub_req_no}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>Time Submitted:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.sub_time_submitted} </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>EMI TYPE:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.sub_emi_type}</div>
                                                        <div className="clearfix"></div>
                                                    </div>

                                                </div>

                                                <div className="col-md-3">
                                                    <div>
                                                        <div className="col-md-8"><label>UTID’s Requested:</label></div>
                                                        <div className="col-md-4 width-40">{this.state.sub_utid_req}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-8"><label>UTID’s Issued:</label></div>
                                                        <div className="col-md-4 width-40">{this.state.sub_utid_issued} </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div>
                                                        <div className="col-md-5"><label>Uploaded Files:</label></div>
                                                        <div className="col-md-7"><input type="text" readOnly="true" value={this.state.uploaded_file} className="width-100"/></div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    {/*<div>*/}
                                                    {/*    <div className="col-md-5"><label>Updated Files:</label></div>*/}
                                                    {/*    <div className="col-md-7"><input type="text" className="width-100"/></div>*/}
                                                    {/*    <div className="clearfix"></div>*/}
                                                    {/*</div>*/}
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="row">
                                                <div className="ro-sep"></div>
                                            </div>
                                            <div className="content-tdetails-table table-full-width table-responsive">
                                                <table id="RequestDetailsTable" className="table table-striped table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th>Ticket No.</th>
                                                        <th>Call ID.</th>
                                                        <th>Merchant Name</th>
                                                        <th>PIN</th>
                                                        <th>City</th>
                                                        <th>State</th>
                                                        <th>Base TID</th>
                                                        <th>Status</th>
                                                        <th>Assignee</th>
                                                        <th>EMI TID</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>

                                                </table>
                                                <div className="gap_ver"></div>
                                                <div className="col-md-3 pull-right">
                                                    {/*<button width="100%" type="button" className="btn btn-secondary">Cancel</button> &nbsp;*/}
                                                    {/*<button width="100%" type="button" className="btn btn-primary" onClick={this.createUTID.bind(this)}>Create UTID</button>*/}
                                                </div>
                                                <div className="clearfix"></div>
                                                <div className="gap_ver"></div>
                                            </div>
                                        </div> : null }

                                    {this.state.ticketDetailsTable===true?
                                        <div className="reqdetailsContain">
                                            <h4 className="nomargin">Ticket Details</h4>
                                            <div className="row">
                                                <div className="col-md-1 back-arrow-div">
                                                    <a href="#" onClick={this.viewType1.bind(this,'')}><i className="fa fa-angle-left" aria-hidden="true"></i></a>
                                                </div>
                                                <div className="col-md-4">
                                                    <div>
                                                        <div className="col-md-5"><label>Ticket No.:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.ticket_no}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>Time:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.created_at}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>


                                                </div>

                                                <div className="col-md-4">
                                                    <div>
                                                        <div className="col-md-5"><label>Merchant:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.merchant_name}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>Assignee:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.assigned_to}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div>
                                                        <div className="col-md-5"><label>Status:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.ticket_status}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>UTID:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.utid}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="row">
                                                <div className="ro-sep"></div>
                                            </div>
                                            <div className="row">


                                                <div className="col-md-4">
                                                    <div>
                                                        <div className="col-md-5"><label>EMI Type:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.emi_type}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>Call ID:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.call_id}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>MCC Code:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.mcc_code}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>Merchant Payback:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.merchant_payback}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div>
                                                        <div className="col-md-5"><label>City:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.city}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>State:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.state}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>PIN:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.pincode}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>Merchant Payback(%):</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.merchant_payback_perc}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>


                                                <div className="col-md-4">
                                                    <div>
                                                        <div className="col-md-5"><label>Base TID:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.base_tid}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>EMAIL ID:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.email_id}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>
                                                    <div>
                                                        <div className="col-md-5"><label>Promo Code:</label></div>
                                                        <div className="col-md-7 width-100">{this.state.ticketDeails.promocode}</div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="gap_ver"></div>


                                                </div>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="row">
                                                <div className="ro-sep"></div>
                                            </div>
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6 det-grp">
                                                <div className="content-tdetails-table table-full-width table-responsive">
                                                    <table id="RequestDetailsTable" className="table table-striped table-hover">
                                                        <thead>
                                                        <tr>
                                                            <th>EMI TID.</th>
                                                            <th>TENURE</th>
                                                            <th>ROI</th>


                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {databtids}
                                                        </tbody>

                                                    </table>
                                                </div>

                                            </div>
                                            <div className="col-md-3"></div>
                                        </div> : null }
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default MyRequests